module.exports = __webpack_public_path__ + "static/media/galleryGT (8).c6c25e5f.jpg";